export const MESSAGES = 
{
    CONFIRMATION_UNSAVED_CHANGES: '',
    CONFIRMATION_FREEZ: 'Are you sure you want to freeze part number ',
    CONFIRMATION_TURNDOWN: 'Are you sure you want to turn down part number ',
    CONFIRMATION_SUPERSEDED: 'Are you sure you want to supersed part number ',
}
